import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  DwComponent,
  DwComponentType,
  DwContainerOptions,
  DwExpressionService,
  DwMetaDataFormApi,
  DwMetaDataFormSectionStateService,
  DwMetaDataFormStateService,
  DwMetaDataService,
  DwMetaDataServiceToken,
  DwSectionReadonlyBaseComponent,
  DwUiConfigRegistryService,
  DwUIMetaDataConfig,
  DwUIMetaDataConfigToken
} from '@devwareapps/devware-cap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AppMetaDataItemNames, DwUserEntity } from '../../../../meta-data/app-meta-data.service';

@DwComponent({
  key: 'student-training-code-form-section',
  name: 'Student Training Code - Form Section',
  componentType: DwComponentType.formSection,
  parentItemName: AppMetaDataItemNames.DwUser,
  isGlobal: false
})
@Component({
  selector: 'app-student-training-code-form-section',
  templateUrl: './student-training-code-form-section.component.html',
  styleUrls: ['./student-training-code-form-section.component.scss']
})
export class StudentTrainingCodeFormSectionComponent extends DwSectionReadonlyBaseComponent implements OnInit, OnDestroy {
  readonly containerOptions: DwContainerOptions = {
    useContainerStyling: true,
    showTitle: true,
    containerHeaderIcon: 'fa fa-key',
    containerClass: 'dw-form-section-container-enhanced',
    containerTitleClass: 'dw-form-section-container-enhanced-header',
    containerInnerClass: 'dw-form-section-container-enhanced-inner-padding'
  };

  studentCode = '';
  copied = false;
  loading = true;

  private readonly formApi: DwMetaDataFormApi;
  private readonly destroy$ = new Subject<void>();
  private copiedTimer: ReturnType<typeof setTimeout>;

  constructor(
    dwExpressionService: DwExpressionService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    dwFormSectionStateService: DwMetaDataFormSectionStateService,
    dwFormStateService: DwMetaDataFormStateService
  ) {
    super(
      dwExpressionService,
      dwFormSectionStateService,
      dwFormStateService,
      dwUiConfigRegistryService,
      uiMetaDataConfig,
      dwMetaDataService
    );
    this.formApi = dwFormStateService.state.formApi;
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.runAfterFormDataLoaded(() => this.updateStudentCode());

    this.formApi.getFormDataChanges()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.updateStudentCode());
  }

  ngOnDestroy(): void {
    if (this.copiedTimer) {
      clearTimeout(this.copiedTimer);
    }

    this.destroy$.next();
    this.destroy$.complete();
  }

  sectionReadOnlyChanged(readOnly: boolean): void {
    return;
  }

  copyCode(): void {
    if (!this.studentCode || !navigator.clipboard) {
      return;
    }

    navigator.clipboard.writeText(this.studentCode).then(() => {
      this.copied = true;

      if (this.copiedTimer) {
        clearTimeout(this.copiedTimer);
      }

      this.copiedTimer = setTimeout(() => this.copied = false, 2000);
    });
  }

  private updateStudentCode(): void {
    const user = this.formApi.getFormData<DwUserEntity>();
    this.studentCode = user?.Student?.StudentCode?.trim() || '';
    this.loading = false;
  }
}
